'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _lodash = require('lodash');

var _bdcoreUtilities = require('@bd/bdcore-utilities');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BlogpostConstructor(_ref) {
  var defaults = _ref.defaults,
      builder = _ref.builder,
      blogpost = _ref.blogpost,
      router = _ref.router;

  var published = (0, _moment2.default)((0, _lodash.get)(blogpost, 'date'));
  var created = (0, _moment2.default)((0, _lodash.get)(blogpost, '_created'));
  var LocalBusiness = defaults['ld+json'].find(function (data) {
    return data['@bdType'] === 'Company';
  });

  var elements = {
    'ld+json': [{
      '@context': 'http://schema.org',
      '@type': 'BlogPosting',
      headline: (0, _lodash.get)(blogpost, 'title'),
      image: (0, _lodash.get)(blogpost, 'logo.contentUrl'),
      keywords: (0, _lodash.get)(blogpost, 'tags', ''),
      wordcount: (0, _lodash.get)(blogpost, 'textbody', '').trim().split(/\s+/).length,
      url: '' + LocalBusiness.url + (0, _lodash.get)(router, 'location.pathname', ''),
      publisher: LocalBusiness,
      datePublished: published.toISOString(),
      dateCreated: (created.isAfter(published) ? published : created).toISOString(),
      dateModified: (0, _moment2.default)((0, _lodash.get)(blogpost, '_updated')).toISOString(),
      articleBody: (0, _lodash.get)(blogpost, 'textbody'),
      author: {
        '@type': 'Person',
        name: (0, _lodash.get)(builder, 'name')
      },
      mainEntityOfPage: '' + LocalBusiness.url + (0, _lodash.get)(router, 'location.pathname', '')
    }],
    title: {
      content: (0, _lodash.get)(blogpost, 'title') + ' | ' + builder.name,
      attrs: {}
    },
    meta: [{
      name: 'description',
      content: ((0, _lodash.get)(blogpost, 'textbody', (0, _lodash.get)(blogpost, 'title')) || '').slice(0, 500)
    }, {
      property: 'og:image',
      content: (0, _bdcoreUtilities.buildThumbnailUrl)((0, _lodash.get)(blogpost, 'logo.contentUrl'), { width: 1200, height: 1200 })
    }, {
      property: 'og:title',
      content: (0, _lodash.get)(blogpost, 'title') + ' | ' + builder.name
    }, {
      property: 'og:description',
      content: ((0, _lodash.get)(blogpost, 'textbody', (0, _lodash.get)(blogpost, 'title')) || '').slice(0, 500)
    }, {
      property: 'og:type',
      content: 'article'
    }]
  };

  return elements;
}

exports.default = BlogpostConstructor;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-pagehelmet/build/Blogpost.js
// module id = 1128
// module chunks = 0